import { branch } from '../constants'

module.exports = ->
  try
    await Weaver.Branch.createBranch(branch)
  catch
    console.warn '$config branch exists, skipping...'